<template>
  <div class="loginbox">
    <div class="login">
      <div class="logo-group"></div>
      <div class="input-group">
        <div class="input-box border">
          <input v-model.trim="mp" type="tel" class="tel" placeholder="手机号"  maxlength="11" @input="onlyNum">
          <span v-if="countDown" class="get-code">{{time}}s</span>
          <span v-else v-on:click="postSmsCaptcha" class="get-code">获取验证码</span>
        </div>
        <div class="input-box border">
          <input v-model.trim="captcha" type="number" placeholder="验证码" maxlength="6" oninput="if(value.length>6) value = value.slice(0,6)">
        </div>
      </div>
      <p class="tips">如果您还没有用这个手机号注册过俺来也，我们将为您创建俺来也账号。</p>
      <span @click.stop="postSignIn" class="btn btn-main btn-lg btn-block">登 录</span>
    </div>
    <!--吃豆子验证弹框-->
    <div class="mask" v-if="showDrag" style="z-index: 105">
      <div class="drag">
        <div class="close-btn" @click="showDrag = false">×</div>
        <h3>请您通过验证</h3>
        <div class="drag_box">
          <ul class="drag_bg">
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
          </ul>
          <div class="handler_bg"></div>
          <div @touchstart="mouseDownFn($event)" class="handler"></div>
        </div>
        <p>向右滑吃掉豆子~</p>
      </div>
    </div>
  </div>
</template>

<script>
  import {actions} from '../store/actions'
  // import { MessageBox, Indicator} from 'mint-ui'

  export default {
    data () {
      return {
        graph_token: '',
        mp: '',
        captcha: '',
        countDown: false,
        time: 60,
        dialogClientX: 0,//弹框距离屏幕左端距离
        beginClientX: 0,//滑块距离屏幕左端距离
        mouseMoveStata: false, //触发拖动状态 判断
        maxWidth: '',//拖动最大宽度，依据滑块宽度算出来的
        confirmSuccess: false, /*验证成功判断*/
        showDrag: false,//二次验证弹框
        hideAly: false, // 是否隐藏俺来也相关
      }
    },
    computed: {
      wxToken () {
        return this.$store.state.wxToken
      },
      schoolInfo () {
        return this.$store.state.schoolInfo
      }
    },
    mounted () {
      // let urlSource = localStorage.getItem('urlSource');
      // if(urlSource && urlSource == 'yjy'){
      //   this.hideAly = true;
      // }
      let _this = this
      /**
       * 如果有指定学校id
       */
      let url_school_id = _this.$utils.resolveUrl().school_id
      if (url_school_id) {
        actions.postSchoolStatus(_this, {school_id: url_school_id}, function (data) {
          let schoolInfo = {
            schoolId: data.school_id,
            schoolName: data.school_name
          }
          _this.$store.commit('changeSchoolInfo', schoolInfo)

        }, function () {
          _this.$messagebox.alert(data.body.message, '')
        })
      } else {
        if (_this.$store.state.schoolInfo && _this.$store.state.schoolInfo.schoolId) {
          // _this.$router.push({path: `/chooseschool`})
        } else {
          _this.$router.push({path: `/chooseschool`})
          return false
        }
      }
      this.addLog()
    },
    methods: {
      addLog() {
        // 内部统计
        var _this = this;
        var params = {
          logDetails: [{uid: _this.$store.state.wxUid, code: 'aly_wechat_login', createTime: new Date().getTime(), firstValue: this.$utils.getCookie('UM_distinctid')}]
        }
        actions.postLogAdd(_this, params, function (data) {
          console.log('记录成功');
        }, function (data) {

        })
      },
      mouseDownFn(e) {
        this.mouseMoveStata = true;
        this.beginClientX = e.changedTouches[0].clientX;
      }, //按下滑块函数
      mouseMoveFn(e) {
        if(this.mouseMoveStata){
          let width = e.changedTouches[0].clientX - this.beginClientX;
          if(width>0 && width <= this.maxWidth){
            document.getElementsByClassName('handler')[0].style.left = width/50 + 'rem';
            document.getElementsByClassName('handler_bg')[0].style.width = (width+10)/50 + 'rem';
          }else if(width>this.maxWidth){
            this.successFunction();
          }
        }
      },
      mouseUpFn(e){
        this.mouseMoveStata = false;
        var width = e.changedTouches[0].clientX - this.beginClientX;
        if(width<this.maxWidth){
          document.getElementsByClassName('handler')[0].style.left = 0 + 'rem';
          document.getElementsByClassName('handler_bg')[0].style.width = 0 + 'rem';
        }
      },
      successFunction() {
        this.confirmSuccess = true
        if(window.addEventListener){
          document.getElementsByTagName('html')[0].removeEventListener('touchmove',this.mouseMoveFn);
          document.getElementsByTagName('html')[0].removeEventListener('touchend',this.mouseUpFn);
        }else {
          document.getElementsByTagName('html')[0].removeEventListener('touchend',()=>{});
        }
        document.getElementsByClassName('handler')[0].style.left = this.maxWidth/50 + 'rem';
        document.getElementsByClassName('handler_bg')[0].style.width = (this.maxWidth+10)/50 + 'rem';
        this.showDrag = false;
        this.postSmsCaptcha();
      },//验证成功函数
      onlyNum: function(){
        var _this = this
        var patt = _this.mp.replace(/[^\d]/g,'')
        if(_this.mp != patt){
          _this.mp = patt
          _this.$messagebox.alert('只能输入数字','')
        }
      },
      // 发送短信验证码
      postSmsCaptcha: function () {
        var _this = this
        if (_this.mp === '') {
          _this.$messagebox.alert('请输入手机号码','')
          return false
        }
        var phonereg = /^1[0-9]{10}$/;
        if (!phonereg.test(_this.mp)) {
          _this.$messagebox.alert('请输入正确格式的手机号', '')
          return false;
        }
        var params = {
          graph_token: _this.graph_token,
          // mp: _this.mp,
          mp_encryption: _this.$utils.Encrypt(_this.mp),
          type: '101',
        }
        actions.postSendCaptcha(_this, params, function (data) {
          if(data.status==0){
            _this.$messagebox.alert('短信已发送成功!请注意查收','')
            _this.countDownFn()
          }else{
            _this.graph_token = data.graph_token;
            _this.showDrag = true;
            setTimeout(function(){
              _this.dialogClientX = document.getElementsByClassName('drag')[0].offsetLeft;
              _this.maxWidth = document.getElementsByClassName('drag_box')[0].offsetWidth - document.getElementsByClassName('handler')[0].offsetWidth;  //能滑动的最大间距
              document.getElementsByTagName('html')[0].addEventListener('touchmove', _this.mouseMoveFn);
              document.getElementsByTagName('html')[0].addEventListener('touchend', _this.mouseUpFn)
            }, 1000);

          }

        })
      },
      // 登录注册
      postSignIn: function () {
        var _this = this;
        if (_this.mp === '') {
          _this.$messagebox.alert('请输入手机号码','')
          return false
        }
        if (_this.captcha === '') {
          _this.$messagebox.alert('请输入短信验证码','')
          return false
        }

        var params = {
          school_id: _this.$store.state.schoolInfo.schoolId,
          captcha: _this.captcha,
          captcha_type: 101,
          mp: _this.mp,
          mp_encryption: _this.$utils.Encrypt(_this.mp),
          // token:'e2fbf9af5cd3373d5de6fb76f61e990e'
          token: _this.$store.state.wxToken,
          client_type: localStorage.getItem('platformType')
        }

        /**
         * 是否是单校区*/
        var school_lock = window.localStorage.getItem('school_lock')
        if (school_lock == '1') {
          params.ref = 'other_wechat'
        } else {
          params.ref = 'aly_wechat'
        }

        console.log(params)
        actions.postSignIn(_this, params, function (data) {
          let openid = _this.$store.state.openId
          if(data.openid && data.openid!=''){
             openid = data.openid
          }

          let userInfo = {
            avatar: data.avatar || data.headimgurl,
            nickname: data.nickname,
            mp: data.mp,
            sex: data.sex,
            mp_real: _this.$utils.Decrypt(data.mp_encryption),
          }


          _this.$store.commit('changeUserInfo', userInfo)

          var obj = {
            wxUid: data.uid,
            wxToken: data.token,
            openId: openid,
            wxLoginToken: data.login_token,
            platformType: data.platform_type
          };
          _this.$store.commit('changeState', obj);
          window.localStorage.removeItem('selfTakeMp');
          // 方便二级域名下获取
          _this.$utils.setCookie('alywechatToken', data.login_token);
          if(document.domain.indexOf('xiyoushi.com') >= 0){
            _this.$router.push({name: 'TagPage'});
          }else{
            _this.$router.go(-1);
          }

        })
      },
      // 60s倒计时方法
      countDownFn: function () {
        var _this = this
        _this.time = 60
        function setTime () {
          if (_this.time === 0) {
            _this.countDown = false
            return false
          } else {
            _this.countDown = true
            _this.time--
          }
          setTimeout(function () {
            setTime()
          }, 1000)
        }
        setTime()
      }
    }
  }
</script>
<style scoped>
  .drag {
    width:6rem;
    height: 4rem;
    text-align: center;
    background: #fff;
    border: 1px solid #ddd;
    position: fixed;
    top: 50%;
    margin-top: -2rem;
    left: 50%;
    margin-left: -3rem;
  }
  .drag h3{
    font-size: 0.3rem;
    color: #000;
    font-weight: normal;
  }
  .drag p{
    font-size: 0.28rem;
    color: #ccc;
  }
  .drag_box{
    width: 80%;
    height: 1rem;
    margin: 0.7rem auto 0.5rem;
    display: flex;
    align-items: center;
    position: relative;
  }
  .handler {
    width: 0.94rem;
    height: 0.93rem;
    background-color: #fff;
    background: url("../assets/images/drag_loading_cat.png") no-repeat;
    background-size: 0.94rem 0.93rem;
    cursor: move;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 10;
  }
  .handler_bg{
    background: #fff;
    height: 0.93rem;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 9;
  }
  .drag_bg {
    width: 100%;
    height: 0.3rem;
    display: flex;
  }

  .drag_bg li {
    width: 0.3rem;
    height: 0.3rem;
    border: none;
    background: url("../assets/images/drag_loading_food.png") no-repeat;
    background-size: 0.3rem;
    margin: 0 0.25rem;
  }
  .close-btn{
    width: 1rem;
    height: 1rem;
    line-height: 1rem;
    font-size: 0.4rem;
    color: #ccc;
    position: absolute;
    top: 0;
    right: 0;
  }
</style>



// WEBPACK FOOTER //
// Login.vue?62acad14